module.exports = __webpack_public_path__ + "img/rules_12.50e5a0a1.png";